<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <eneTrackerFormBox
        list-url="/complain"
        :id="id"
        checklist-type="complain"
        :form-type="formType"
        @add="onAdd"
        @edit="onEdit"
        :loading="loading"
      >
      </eneTrackerFormBox>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import router from '@/router';
import eneTrackerFormBox from '../../components/EnETrackerFormBox.vue';

export default {
  name: 'ComplainForm',
  components: {
    eneTrackerFormBox
  },
  async mounted() {
    if (this.$route.name === 'ene-tracker-new') {
      this.formType = 'new';
      this.id = null;
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;

      await this.getOne({
        type: 'complain',
        id: this.id,
        router
      });
    }
  },
  data() {
    return {
      formType: '',
      id: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Add New' : 'Update One';
    },
    ...mapState('transactionComplain', ['loading', 'baseUrl', 'pagination', 'complainList', 'imageUrl']),
    ...mapState('auth', ['user']),
    ...mapState('cstSubmission', ['store'])
  },
  methods: {
    ...mapActions('eneTracker', ['getOne', 'postOne', 'patchOne', 'getImageUrl']),
    ...mapActions('cstSubmission', ['getStoreByUser']),
    onAdd({ complain }) {
      this.postOne({
        complain,
        router,
        redirectUrl: '/eneTracker'
      });
    },
    onEdit({ complain }) {
      this.patchOne({
        type: 'complain',
        id: this.id,
        complain,
        router,
        redirectUrl: '/eneTracker'
      });
      // if (complain.images && complain.images.length > 0) {
      //   this.imagePreview = complain.images;
      // }
    }
  }
};
</script>
